import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalizarPedidoInputService {
  public estaFocado = false;
  public novoValorParaSetar = '';
  public campoSenhaComFoco = false;

  public get existeValorParaSetar() {
    return this.novoValorParaSetar !== '';
  }

  public limparValorParaSetar() {
    this.novoValorParaSetar = '';
  }
}
